<template>
  <v-modal
    animation="slide-up"
    block-scroll
    theme="light-grey"
    :full="!screen.breakPoint.tabPort"
    handle-click-bg
    v-model="show"
    :position="!screen.breakPoint.tabPort ? 'bottom' : 'top'"
  >
    <template v-slot:activator="{ on }">
      <box class="mb-1" clickable @click="on()">
        <div class="dashboard-actions-item d-flex justify-stretch align-center">
          <div><span class="icon-qr_code text--xxx-large rotate-90 d-inline-block"></span></div><div class="ml-2 text--medium">{{ $t('widgets.Dashboard.DashboardActions.QrCheck.title') }}</div>
        </div>
      </box>
    </template>

    <template v-slot:header>
      <div>{{ $t('widgets.Dashboard.DashboardActions.QrCheck.title') }}</div>
    </template>

    <div v-if="!showReceipt">
      <v-input type-name="number" v-model="formData.receiptNumber" :placeholder="$t('widgets.Dashboard.DashboardActions.QrCheck.receiptNumber')" type="number" min="0" class="mb-2"></v-input>
      <date-input :is24hr="$i18n.locale !== 'en'" mode="dateTime" v-model="formData.purchaseDateAndTime" class="mb-2" :placeholder="$t('widgets.Dashboard.DashboardActions.QrCheck.purchaseDateAndTime')"></date-input>
      <v-input type-name="number" v-model="formData.totalAmount" :placeholder="$t('widgets.Dashboard.DashboardActions.QrCheck.totalAmount')" class="mb-3" type="number" min="0"></v-input>
      <autocomplete value-field="id" item-text="number" v-model="formData.terminalId" :items="computedTerminals" class="mb-2" :placeholder="$t('widgets.Dashboard.DashboardActions.QrCheck.terminalNumber')"></autocomplete>
      <v-input type-name="number" v-if="ShowFpFieldQrCheck" v-model="formData.fp" :placeholder="$t('widgets.Dashboard.DashboardActions.QrCheck.fiscalAttribute')" type="number" min="0" class="mb-2"></v-input>
      <autocomplete value-field="id" item-text="fullName" v-model="selectedContact" :items="contracts" :placeholder="$t('widgets.DashboardActions.ResponseQr.contractPlaceholder')"></autocomplete>
    </div>

    <div class="dashboard-actions-item d-flex justify-center align-center m-3" v-else>
      <qr-code :loading="$apollo.queries.qrReceipt.loading" :content="qrReceipt" v-if="selectedContact"></qr-code>
      <qr-code v-else></qr-code>
    </div>

    <template #footer>
      <v-button
        width="full"
        :disabled="!showReceipt && (!formData.totalAmount || !formData.receiptNumber || !formData.purchaseDateAndTime)"
        @click="showReceipt = !showReceipt"
      >
        <div class="d-flex align-center justify-center">
          <div v-if="!showReceipt">{{ $t('widgets.Dashboard.DashboardActions.QrCheck.generate') }}</div>
          <div v-else>{{ $t('widgets.Dashboard.DashboardActions.QrCheck.reGenerate') }}</div>

          <div v-if="showReceipt" class="icon-undo-small text-color-white ml-1 text--large"></div>
        </div>
      </v-button>
    </template>
  </v-modal>
</template>

<script>
import Box from '@/ui/slots/Box'
import vModal from '@/ui/modals/vModal'
import vInput from '@/ui/controls/vInput'
import vButton from '@/ui/controls/vButton'
import Autocomplete from '@/ui/controls/Autocomplete'
import DateInput from '@/ui/controls/DateInput'
import QrCode from '@/ui/elements/QrCode'

import contracts from '@/mixins/contracts'
import screen from '@/mixins/screen'
import { ShowFpFieldQrCheck } from '@/mixins/displayRules'

import { ReceiptQrGQL, TerminalsGQL } from '@/graphql/queries'
import currContractId from '@/mixins/currContractId'

export default {
  components: {
    vModal,
    vInput,
    vButton,
    Autocomplete,
    DateInput,
    QrCode,

    Box
  },

  mixins: [currContractId, contracts, ShowFpFieldQrCheck, screen],

  data () {
    return {
      showReceipt: false,
      show: false,

      formData: {
        selectedContact: null,
        terminalId: null,
        receiptNumber: null,
        purchaseDateAndTime: new Date().toISOString(),
        totalAmount: null,
        fp: null
      }
    }
  },

  apollo: {
    qrReceipt: {
      query: ReceiptQrGQL,
      variables () {
        return {
          params: {
            amount: this.formData.totalAmount,
            checkDate: this.formData.purchaseDateAndTime,
            contractId: this.selectedContact,
            fp: this.formData.fp,
            numberCheck: this.formData.receiptNumber,
            terminalId: this.formData.terminalId
          }
        }
      },
      update: data => data.merchant.qr.receiptQr,
      skip () { return !this.showReceipt }
    },

    terminals: {
      query: TerminalsGQL,
      variables () {
        return {
          params: {
            filter: {
              active: true
            }
          }
        }
      },
      update: data => data.merchant.terminals,
      skip () { return !this.show }
    }
  },

  computed: {
    computedTerminals () {
      if (!this.terminals) {
        return []
      }

      return this.terminals.content
    },

    selectedContact: {
      get () {
        if (this.formData.selectedContact) {
          return this.formData.selectedContact
        }

        return this.currContractId
      },

      set (val) {
        this.formData.selectedContact = val
      }
    }
  },

  watch: {
    show (val) {
      if (!val) {
        this.showReceipt = false
      }
    }
  }
}
</script>

<style lang="scss"></style>
